import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { StoresComponent } from './pages/stores/stores.component';
import { StoreFormComponent } from './pages/stores/store-form/store-form.component';
import { LayoutComponent } from './layout/layout.component';
import { UserComponent } from './pages/user/user.component';
import { UserVisitComponent } from './pages/user/user-visit/user-visit.component';
import { TermsCondtitionComponent } from './terms-condtition/terms-condtition.component';
import { AdminListComponent } from './pages/admin/admin-list.component';
import { AdminFormComponent } from './pages/admin/admin-form/admin-form.component';
import { AddUserComponent } from './pages/user/add-user/add-user.component';
import { OnboardingImagesComponent } from './pages/onboarding-images/onboarding-images.component';
import { GraphComponent } from './graph/graph.component';
import { DoorStatusComponent } from './door-status/door-status.component';
import { NotificationComponent } from './pages/notification/notification.component';
import { HolidaysComponent } from './pages/holidays/holidays.component';
import { AddHolidaysComponent } from './pages/holidays/add-holidays/add-holidays.component';
import { CardUidManagerComponent } from './pages/card-uid-manager/card-uid-manager.component';
import { UserCardsComponent } from './pages/user/user-cards/user-cards.component';
import { BlockedCprListComponent } from './pages/blocked-cpr/blocked-cpr-list.component';
import { AddBlockedCprComponent } from './pages/blocked-cpr/add-blocked-cpr.component';
import { UploadBlockedCprComponent } from './pages/blocked-cpr/upload-blocked-cpr.component';
import { NfcMonitoringComponent } from './pages/nfc-monitoring/nfc-monitoring.component';
import { StoreNfcMonitoringComponent } from './pages/nfc-monitoring/store-nfc-monitoring/store-nfc-monitoring.component';
import { EcommerceAdminComponent } from './pages/stores/ecommerce-admin/ecommerce-admin.component';
import { ManagerEcommerceComponent } from './pages/stores/manager-ecommerce/manager-ecommerce.component';
import { AuditorOrdersComponent } from './pages/stores/auditor-orders/auditor-orders.component';
import { SecuritySettingsComponent } from './pages/security-settings/security-settings.component';
import { ChainsListComponent } from './pages/chains/chains-list/chains-list.component';
import { ChainFormComponent } from './pages/chains/chain-form/chain-form.component';
import { ChainReportsComponent } from './pages/chains/chain-reports/chain-reports.component';
import { MyChainsDashboardComponent } from './pages/my-chains/my-chains.component';
import { ChainBrandingComponent } from './pages/chains/chain-branding/chain-branding.component';
import { ChainCatalogComponent } from './pages/chains/chain-catalog/chain-catalog.component';
import { ChainLoyaltyComponent } from './pages/chains/chain-loyalty/chain-loyalty.component';
import { ChainOverviewComponent } from './pages/chains/chain-overview/chain-overview.component';
import { DeveloperClientsListComponent } from './pages/developer-clients/developer-clients-list/developer-clients-list.component';
import { SsoApplicationsListComponent } from './pages/sso-applications/sso-applications-list/sso-applications-list.component';
import { PosTerminalsComponent } from './pages/stores/pos-terminals/pos-terminals.component';
import { PosTerminalFormComponent } from './pages/stores/pos-terminals/pos-terminal-form.component';
import { SupportCenterComponent } from './pages/support/support-center.component';
import { TicketListComponent } from './pages/support/tickets/ticket-list.component';
import { TicketCreateComponent } from './pages/support/tickets/ticket-create.component';
import { TicketDetailComponent } from './pages/support/tickets/ticket-detail.component';
import { KbListComponent } from './pages/support/knowledge-base/kb-list.component';
import { KbArticleComponent } from './pages/support/knowledge-base/kb-article.component';
import { KbArticleFormComponent } from './pages/support/knowledge-base/kb-article-form.component';
import { DepositFeeCatalogComponent } from './pages/deposit-fee-catalog/deposit-fee-catalog.component';
import { GlobalCatalogComponent } from './pages/global-catalog/global-catalog.component';
import { InfoPageComponent } from './pages/info-page/info-page.component';
import { QrLandingPageComponent } from './pages/qr-landing-page/qr-landing-page.component';
import { MobileDiagnosticsComponent } from './pages/mobile-diagnostics/mobile-diagnostics.component';
import { UnassignedInvoiceImportsComponent } from './pages/invoice-imports/unassigned-invoice-imports/unassigned-invoice-imports.component';
import { WholesalerDefinitionsAdminComponent } from './pages/invoice-imports/wholesaler-definitions-admin/wholesaler-definitions-admin.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
      },
      { path: 'graph', component: GraphComponent, canActivate: [AuthGuard] },
      {
        path: 'adminlist',
        component: AdminListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'adminregister',
        component: AdminFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'adminedit/:id',
        component: AdminFormComponent,
        canActivate: [AuthGuard],
      },
      { path: 'stores', component: StoresComponent, canActivate: [AuthGuard] },
      {
        path: 'storeforms',
        component: StoreFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'editstore/:id',
        component: StoreFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'doorstatus',
        component: DoorStatusComponent,
        canActivate: [AuthGuard],
      },
      { path: 'users', component: UserComponent, canActivate: [AuthGuard] },
      {
        path: 'adduser',
        component: AddUserComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'edituser/:id',
        component: AddUserComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'uservisit',
        component: UserVisitComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'termsandconditions',
        component: TermsCondtitionComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'onboardingimages',
        component: OnboardingImagesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'notification',
        component: NotificationComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'holidays',
        component: HolidaysComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'addholidays',
        component: AddHolidaysComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'editholiday/:id',
        component: AddHolidaysComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'carduidmanager',
        component: CardUidManagerComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'user-cards/:id',
        component: UserCardsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'blocked-cpr',
        component: BlockedCprListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'blocked-cpr/add',
        component: AddBlockedCprComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'blocked-cpr/upload',
        component: UploadBlockedCprComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'nfc-monitoring',
        component: NfcMonitoringComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'nfc-monitoring/store/:id',
        component: StoreNfcMonitoringComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'store/:id/ecommerce',
        component: EcommerceAdminComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'store/:id/pos-terminals',
        component: PosTerminalsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'store/:id/pos-terminals/new',
        component: PosTerminalFormComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'store/:id/pos-terminals/:terminalId/edit',
        component: PosTerminalFormComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'manager-ecommerce',
        component: ManagerEcommerceComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'auditor-orders',
        component: AuditorOrdersComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'security-settings',
        component: SecuritySettingsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'chains',
        component: ChainsListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'chainforms',
        component: ChainFormComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'editchain/:id',
        component: ChainFormComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'chain-reports/:id',
        component: ChainReportsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'my-chains',
        component: MyChainsDashboardComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'chain/:chainId/branding',
        component: ChainBrandingComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'chain/:chainId/catalog',
        component: ChainCatalogComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'chain/:chainId/loyalty',
        component: ChainLoyaltyComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'chain/:chainId/overview',
        component: ChainOverviewComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'developer-clients',
        component: DeveloperClientsListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'sso-applications',
        component: SsoApplicationsListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'support',
        component: SupportCenterComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'support/tickets/new',
        component: TicketCreateComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'support/tickets/:id',
        component: TicketDetailComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'support/articles/new',
        component: KbArticleFormComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'support/articles/:id/edit',
        component: KbArticleFormComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'support/articles/:id',
        component: KbArticleComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'deposit-fee-catalog',
        component: DepositFeeCatalogComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'global-catalog',
        component: GlobalCatalogComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'invoice-imports/unassigned',
        component: UnassignedInvoiceImportsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'admin/wholesaler-definitions',
        component: WholesalerDefinitionsAdminComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'infopage',
        component: InfoPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'qrlandingpage',
        component: QrLandingPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'mobile-diagnostics',
        component: MobileDiagnosticsComponent,
        canActivate: [AuthGuard]
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
